import { Navigate, Outlet, useLocation } from 'react-router'
import { useAppSelector } from 'universal-scripts'

export default function RequireAuth() {
  const isLoggedIn = useAppSelector((state) => !!state.user)
  const location = useLocation()

  if (!isLoggedIn) {
    if (__SERVER__) {
      return null
    }
    const from = location.pathname + location.search + location.hash
    return <Navigate to="/login" state={{ from }} replace />
  }

  return <Outlet />
}
